import React from 'react';
import createSvgIcon from '../../../shared/utils/create-svg-icon';
import LoadingSpinnerBlueImg from '../../../assets/icon-loading-spinner-blue.png';

export const LoadingSpinnerBlueIcon = createSvgIcon((<image href={LoadingSpinnerBlueImg} height="16" width="16" />), 'LoadingSpinnerBlueIcon');
